import React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import './styles.css'

const Header = () => (
  <header className={cx('blog-header')}>
    <div className={cx('blog-title-container')}>
      <h1 className={cx('blog-title')}><Link to='/' className={cx('title-link')}>Pianeer</Link></h1>
      <p className={cx('blog-subtitle')}>
        Sporadic <span className={cx('underline')}>Pia</span>nist. Continuous Engi<span className={cx('underline')}>neer</span>.
      </p>
      <p className={cx('blog-subtitle')} />
    </div>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/client/components/header/index.js